import React from "react";
import {
    Dialog,
    DialogContent,
    DialogActions,
    Grid,
    Button,
    TextField,
    colors,
    DialogTitle,
} from "@material-ui/core";
import { useStylesLbl } from "../../../../../St/Reports/UseStyle";
import ItemsDetailsFilter from "../ItemInfo/ItemsDetailsFilter";
import { useStylesTF } from "../../../../../St/comps/UseStyle";
import { useStylesItemDilog } from "../ItemDataDialog";
import { uri } from "../../../../../help/Api";
import { sto } from "../../../../../Context/InshData";
import axios from "axios";
import { ArrowDownward } from "@material-ui/icons";

export default function ItemsFromOthers(props) {
    const { openGetItems, setOpenGetItems, PrTy_InPr, setIsData, handSums,permiCuCo,transForm ,post} = props;
    const classes = useStylesItemDilog();
    const clasTF = useStylesTF();
    const isPurches=PrTy_InPr==="01" || PrTy_InPr==="11" || PrTy_InPr==="04"?true:false;
    const isStock=PrTy_InPr==="22"?true:false;
    const isMake=PrTy_InPr==="33"?true:false;
    const [rptParams, setRptParams] = React.useState({
        id: '',
        doc_type: '001',
    });
    const getCloseDialog = () => {
        setOpenGetItems(false);
        setRptParams({ ...rptParams, doc_type: '001' });
    };
    const type_doc = [
        { id: '01', name: "مشتريات" },
        { id: '11', name: "مرتجع مشتريات" },
        { id: '22', name: "مخزون اول مدة"},
        { id: '23', name: "توريد مخزني"},
        { id: '04', name: transForm("purchase_order")},
    ];
    const type_docSa = [
        { id: '02', name: "مبيعات"},
        { id: '12', name: "مرتجع مبيعات"},
        { id: "03", name: transForm("quotation")},
        { id: "07", name: "فاتورة أولية"},
        { id: "08", name: "امر عمل"},
        { id: '24', name: "صرف مخزني"},
    ];

    const changIdata = (propName) => (event) => {
        setRptParams({ ...rptParams, id: event.target.value })
    }

    const getItemsToInv = async () => {
        if (rptParams.id < 1 || rptParams.doc_type === "001") return;
        const tb = {
            wait: true,
            GetItemToInv: true,
            parms: {
                tname: rptParams.doc_type==="07"||rptParams.doc_type==="08"?"03": rptParams.doc_type ,
                branch: sto.branchi,
                sProcTypeInvProc: PrTy_InPr,
                id: rptParams.id,
                type: rptParams.doc_type == "23" ? 1 : 2,
                bol1: permiCuCo,
                post:post,
                db_name:sto?.db_name
            },
        };

        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                const dataItems = res.data.itemsToInv.map((row, i) => {
                    return {
                        ...row,
                        UnitsTable: [],
                        defUnit: {},
                        no: i,
                        editAbleVal: false,
                        editAblePrice: false,
                        editAbleUnit: false,
                        editAbleTax: false,
                        editAbleDescM: false,
                        editAbleDescP: false,
                        editAbleDescNote: false,
                        type: 1,
                    };
                });
                setIsData(dataItems);
                handSums(dataItems);
                getCloseDialog();
            })
            .catch((error) => {
            });
    };
    const claslbls = useStylesLbl();

    return (
        <Dialog open={openGetItems} classes={{ paper: classes.dialog }}>
            <DialogTitle style={{textAlign:"center"}} > {"Get From Other Ducoments"}</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <Grid container justifyContent="center">
                    <Grid container justifyContent="center" item lg={12} md={12} sm={12} xs={12} >
                        <ItemsDetailsFilter
                            {...{
                                rptParams, setRptParams, isPurches, isStock, isMake,
                                type_doc: PrTy_InPr === "02" || PrTy_InPr === "12" || PrTy_InPr === "03" ? type_docSa : type_doc
                            }} />
                    </Grid>
                </Grid>
                <br/>
                <Grid container justifyContent="center" spacing={1}>
                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ paddingBottom: "0.5rem" }}>
                        <Button
                            fullWidth
                            autoFocus
                            variant="contained"
                            color="primary"
                            onClick={(event) => getItemsToInv(event)}
                            style={{
                                background: PrTy_InPr === "03" ? "#964B00" : isPurches || isStock|| isMake ? "#008080" : colors.green[500],
                                ...{ paddingLeft: 0, paddingRight: 0, },
                            }} startIcon={<ArrowDownward />} >
                            {"تنزيل" + "  "}
                        </Button>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ paddingBottom: "0.5rem" }}>
                        <TextField fullWidth variant="outlined" size="small"
                            id="refno"
                            label={transForm("no")}
                            className={isPurches ? clasTF.rootPurch : clasTF.rootSale}
                            InputLabelProps={{ className: isPurches || isStock|| isMake  ? claslbls.clrBlackLblS : claslbls.clrSale }}
                            type="text"
                            name="refno"
                            value={rptParams.id}
                            onChange={changIdata("id")}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogAction}>
                <Button onClick={() => getCloseDialog()}>إغلاق </Button>
            </DialogActions>
        </Dialog>
    );
}

